export default class WordWrapUtil {
  public static breakWord(s: string, limit: number): string {
    const breakCount = s.length / limit;
    const newname = Array.from(s);
    for (let x = 1; x < breakCount + 1; x++) {
      newname.splice(x * limit + (x - 1), 0, ' ');
    }
    return newname.join('').trimEnd();
  }

  public static wrap(s: string, limit: number): string[] {
    const words = s.split(' ');
    const newSentence = [];

    let line = '';
    for (const word of words) {
      if ((line + word).length > limit) {
        newSentence.push(line.trimEnd());
        line = '';
      }
      line += `${word} `;
    }

    if (line.length > 0) {
      newSentence.push(line.trimEnd());
    }

    return newSentence;
  }

  public static breakWordsOverLimit(s: string, limit: number): string {
    return s
      .split(' ')
      .map((x) => {
        return x.length > limit ? WordWrapUtil.breakWord(x, limit) : x;
      })
      .join(' ');
  }
}
